import { ControlIcons } from 'owa-control-icons';
import type { LinkPayload } from './schema';
import {
    registerAsset,
    AssetAriaLabel,
    LEGACY_DEFAULT_MIN_ASSET_WIDTH,
} from 'owa-timestream-asset-sdk';
import createLinkFromClipboardData from './util/createLinkFromClipboardData';
import LinkView from './components/LinkView';
import loc from 'owa-localize';
import { linkName, linkTooltip, assetErrorLink } from './linkStrings.locstring.json';
import onAssetInvoked from './util/onAssetInvoked';

const LINK_TYPE = 'link';

export default registerAsset<LinkPayload>({
    type: LINK_TYPE,
    iconName: ControlIcons.Link,
    getToolName: () => loc(linkName),
    getTooltip: () => loc(linkTooltip),
    getErrorMessage: () => loc(assetErrorLink),
    unsupportedDefaultCommands: [],
    customRenderDueDate: true,
    CanvasView: LinkView,
    createEmptyAsset: () => ({
        type: LINK_TYPE,
        payload: { url: '' },
        width: LEGACY_DEFAULT_MIN_ASSET_WIDTH,
    }),
    createAssetFromClipboardData: createLinkFromClipboardData,
    onAssetInvoked: onAssetInvoked,
    getAriaLabel: (payload: LinkPayload) =>
        loc(AssetAriaLabel.assetAriaLabel, loc(linkName), payload.url ? payload.url : ''),
    getTitleString: (payload: LinkPayload) => payload.linkPreview?.Title ?? payload.url,
    getSearchString: (payload: LinkPayload) =>
        payload.linkPreview?.Title
            ? payload.linkPreview?.Title + ' ' + (payload.linkPreview?.Description ?? '')
            : payload.url,
});
